/*
    sidebar component should be a component usable for all main views
*/
import React, {useEffect, useState} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import NewTaskButton from './NewTaskButton';
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de"; // @todo Make dynamic
import {ListItem, Span} from "../styled_components/exporter";
import {moment, $} from "../../../../../vendor";
import SidebarFilter from "../../../components/SidebarFilter";
import {getFilterData} from "../../../../utils/Helper";
import {getAllUrlParams} from "../../../../utils";


const TaskSidebar = (props) => {
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    let newTo = null;

    if(allUrlParams?.end_lt !== undefined){
        let sp = allUrlParams?.end_lt.split('+');
        newTo = new Date(sp[0]);
    }
    allUrlParams?.selected !== undefined && delete allUrlParams.selected;
    allUrlParams?.selectedall !== undefined && delete allUrlParams.selectedall;
    allUrlParams?.multiedit !== undefined && delete allUrlParams.multiedit;
    const [taskNbrFilter, setTaskNbrFilter] = useState('');
    const [taskTypeFilter, setTaskTypeFilter] = useState(typeof allUrlParams?.task_type_id !== 'undefined' ? allUrlParams?.task_type_id:'all');
    const [status, setStatus] = useState(typeof allUrlParams?.status !== 'undefined' ? allUrlParams?.status : 'open');
    const [statusFilter, setStatusFilter] = useState({
        value: status
    });
    const [date, setDate] = useState({
        from: null,
        to: newTo,
        day: "ALL"
    });
    const cleanState = {taskNbrFilter:false,date:{
            from: null,
            to: null,
            day: "ALL"
        },statusFilter:{
            value: 'open'
        },taskType: 'all'};
    const [usedFilterCount,setUsedFilterCount] = useState({taskNbrFilter:allUrlParams?.task_nbr !== undefined ? true : false, statusFilter:status !== 'open'?true:false, date:date.to !== null ? true : false, taskType: allUrlParams?.task_type_id !== undefined ? true: false});
    const [filterCount, setFilterCount] = useState(function () {
        let count = allUrlParams?.task_nbr !== undefined ? 1 : 0;
        count += status !== 'all' ? 1 : 0;
        count += date.to !== null ? 1 : 0;
        count += allUrlParams?.task_type_id !== undefined ? 1 : 0;
        return count;
    });
    const [_resetFilter,_setResetFilter] = useState(props.resetFilter);

    const [globalFilter, setGlobalFilter] = useState(status === 'open' ?{
        'find' : '!Done'
    }:{});           // set empty object, there are no filters set by default

    const selectedDateTo = date.to;
    useEffect(() => {

        if (!_resetFilter) return;

        if (_resetFilter) {
            resetFilter(false);
        }
        _setResetFilter(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_resetFilter]);

    const resetFilter = (dispatch = true) =>
    {
        let clone = {
        };
        setStatus('all');
        setTaskNbrFilter('');
        setTaskTypeFilter('all');
        setDate({
            from: null,
            to: null,
            day: "ALL"
        });

        setFilterCount(0);
        setGlobalFilter(clone);
        setUsedFilterCount(cleanState);
        props.setGlobalFilter(cleanState);

        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
    }

    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type, val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };

    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    const handleChangeTo = value => {

        var globalClone = {},
            dateClone = {};
        Object.assign(dateClone,date);
        let clone3 = {...usedFilterCount};
        // set date filter
        if (new Date(value).getFullYear() <= 1970) {
            dateClone.to = null;
            clone3['date'] = false;
            searchParams.delete('end_lt');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            dateClone.to = new Date(value);
            clone3['date'] = true;
            searchParams.set('end_lt', moment(new Date(dateClone.to)).format("YYYY-MM-DD") + " 23:59:59");
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setDate(dateClone);                             // set date filter (dateClone is necessary to keep value in time)

        // update global filter
        Object.assign(globalClone,props.globalFilter);        // get current values of global filter (all filter)
        if (dateClone.to == null) {
            delete globalClone['end_lt'];
            searchParams.delete('end_lt');
            clone3['date'] = false;
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            globalClone.end_lt = moment(new Date(dateClone.to)).format("YYYY-MM-DD") + " 23:59:59";
            searchParams.set('end_lt', moment(new Date(dateClone.to)).format("YYYY-MM-DD") + " 23:59:59");
            clone3['date'] = true;
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }

        //setGlobalFilter(globalClone);
        setUsedFilterCount(clone3);
        setGlobalFilter(globalClone);
        onFilterCountChangeHandle(clone3);
        props.setGlobalFilter(globalClone);
        //props.setSelectedFilter(globalClone);           // cloned object must be used because global filter is not yet updated
    };

    const onStatusFilterChange = (val) => {
        if(val === null){
            val = 'all';
        }
        setStatusFilter({value: val});                  // set status filter
        let clone = {}, clone2 = {};
        Object.assign(clone,props.globalFilter);              // get current filter settings (all filter)
        Object.assign(clone2,props.statusFilter);
        clone2.value = val;
        setStatus(clone2);
        let clone3 = {...usedFilterCount};           // get current filter settings (all filter)
        if (val === 'all') {
            delete clone['find'];
            delete clone['status'];
            clone3.statusFilter = false;
            searchParams.set('status', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else if (val === 'open') {
            clone['find'] = '!Done';
            delete clone['status'];
            clone3.statusFilter = true;
            searchParams.delete('status');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            delete clone['find'];
            clone['status'] = val;
            clone3.statusFilter = true;
            searchParams.set('status', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        /*
        if (val != 'all') {
            // add status filter to global filter
            clone.status = val;
            delete clone['find']; 
        } else {
            // remove status filter from global filter
            clone['find'] = '!Done';
            delete clone['status'];
        }*/
        setUsedFilterCount(clone3);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone3);
        props.setGlobalFilter(clone);
        //setGlobalFilter(clone);
        //props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };


    const onTaskTypeFilterChange = (val) => {
        val = val.target.value;
        setTaskTypeFilter(val);                  // set status filter
        let clone = {}, clone2 = {};
        Object.assign(clone,props.globalFilter);              // get current filter settings (all filter)
        let clone3 = {...usedFilterCount};           // get current filter settings (all filter)
        if (val === 'all') {

            delete clone['task_type_id'];
            clone3.taskType = false;
            searchParams.delete('task_type_id');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else {
            clone['task_type_id'] = val;
            clone3.taskType = true;
            searchParams.set('task_type_id', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        /*
        if (val != 'all') {
            // add status filter to global filter
            clone.status = val;
            delete clone['find'];
        } else {
            // remove status filter from global filter
            clone['find'] = '!Done';
            delete clone['status'];
        }*/
        setUsedFilterCount(clone3);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone3);
        props.setGlobalFilter(clone);
        //setGlobalFilter(clone);
        //props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };

    return (
        <aside
            id="inb-c-sidebar"
            className="filemanager-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title sticky-top">
                <h1 className="inb-page-title">
                {t("task_list",null,"capital")}
                </h1>
            </header>
            
          {/*  {props.tasks.length === 0 &&
            <div>
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-top">
                        <div className="inb-c-loader--bg row">
                        </div>
                    </div>
                </div>
                
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-center">
                        <div className="inb-c-loader--bg row">
                            <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                            <div className="loader-mask vert-ph-1"></div>
                            <div className="loader-mask vert-ph-2"></div> 
                            <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                            <div className="loader-mask vert-ph-3"></div> 
                            <div className="loader-mask vert-ph-4"></div> 
                        </div>
                    </div>
                </div>
            
                <div className="inb-c-loader">
                    <div className="inb-c-loader--item inb-c-loader--sidebar-center">
                        <div className="inb-c-loader--bg row">
                            <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                            <div className="loader-mask vert-ph-1"></div>
                            <div className="loader-mask vert-ph-2"></div> 
                            <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                            <div className="loader-mask vert-ph-3"></div> 
                            <div className="loader-mask vert-ph-4"></div> 
                        </div>
                    </div>
                </div>
            </div>
            }*/}
            <div className="sticky-top-filter">
                <aside id="inb-selected-filters">
                    {filterCount > 0 && <ul>
                        <p>
                            <i className="fi fi-filter"></i>
                            <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                            {" " + t('filter_selected')}
                            <a href="#"
                               id="inb-selected-filters__unset"
                               className="unset-filter"
                               title={t('unselect_all_filter')} onClick={() => {
                                resetFilter(true)
                            }}>
                                x
                            </a>
                        </p>
                    </ul>}
                </aside>
            {<SidebarFilter
                id="inb-c-left-bar-flist--task-status"
                heading={t('task_status')}
                type="list"
                data={
                    getFilterData( [
                        {name: t('all'), summaryItem: "allCount", value: 'all'},
                        {name: t('open'), summaryItem: "openCount", value: 'open'},
                        {name: t('new'), summaryItem: "newCount", value: 'new'},
                        {name: t('inprogress'), summaryItem: "inprogressCount", value: 'inprogress'},
                        {name: t('done'), summaryItem: "doneCount", value: 'done'}
                    ], props.summaryPending, props.summary)
                }
                dataKey="value"
                selected={statusFilter.value}
                summaryPending={props.summaryPending}
                onChangeHandle={onStatusFilterChange}/>}

           {/* <ul id="inb-c-left-bar-flist--task-status"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('task_status')}
                </span>
              {['all', 'open', 'new','inprogress','done'].map(status => (
              <ListItem
                  className={status === statusFilter.value ? 'active' : ''}
                  key={status}>

                  <span onClick={() => onStatusFilterChange(status)}>
                    {status == "inprogress" ? t('in_progress') : t(status)}
                  </span>

                  {statusFilter.value !== null && statusFilter.value !== 'all' && statusFilter.value == status &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onStatusFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>*/}

            <hr />
                <ul id="inb-c-left-bar-flist--resource-contingent"
                    className="inb-vert-list">
                <span className="inb-list-title">
                    {t('task type',null,'capital')}
                </span>
                    <select
                        className="inbooma-select-box__input"
                        name="task_type_id"
                        onChange={(e) => onTaskTypeFilterChange(e)}
                        value={taskTypeFilter}
                        placeholder={t('select_${a}',{a:t('task type')})}>
                        <option key={'all'} value={'all'}>{t('all')}</option>
                        {props.taskTypes.map(taskType => {
                            return(
                                <>
                                    <option key={taskType.id} value={taskType.id}>{taskType.name}</option>
                                </>
                            )
                        })}
                    </select>
                    {taskTypeFilter !== undefined && taskTypeFilter !== null && taskTypeFilter !== 'all' &&
                        <a href="#" className="inbooma-select-box__reset" onClick={() => onTaskTypeFilterChange({target:{value:'all'}})} style={{float:'unset', paddingLeft:'15px'}}>
                            x
                        </a>
                    }
                </ul>
            <ul 
                id="inb-c-left-bar-flist--dates"
                className="inb-vert-list"
                data-inb-filter="from-to-date"
                data-inb-multiple>
                <span className="inb-list-title">
                    {t('done_until')}
                </span>
                <ListItem>
                    <>
                    <DatePicker
                        className="noBorders-noBackground"
                        dateFormat="dd.MM.y"
                        selected={selectedDateTo}
                        onChange={date => handleChangeTo(date)}
                        onKeyDown={e => {
                        if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText={' ...' + t('valid_to',null,'capital')}
                        locale={de}
                    />
                    {selectedDateTo !== null &&
                    <Span onClick={() => handleChangeTo(null)}>
                        <i className="fi fi-x"> </i>
                    </Span>
                    }
                    </>
                </ListItem>
            </ul>
            </div>
            {rbac.hasPermission('write') &&
                <footer
                 className="inb-c-left-bar__footer small-only-float-container"
                 data-inb-action-link="write">
                     <a href="#"
                        id="toggle-left-bar"
                        className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                            <i className="fi fi-filter"> </i>
                            <span className="show-for-sr">t('open_filter_menu')</span>
                    </a>
                    <NewTaskButton
                    />
                </footer>
            }
        </aside>
    );
};

export default TaskSidebar;